import Icon from '../../../../baseComponents/gui/icon/Icon';

export default function Charm({ charm }) {
  return (
    charm && (
      <div className={'button__coins button_transparent custom-button__coins'}>
        <Icon name={'charm'} />
      </div>
    )
  );
}
